export default __webpack_public_path__ + "static/media/covidImg2.375ad162.png";